const steps = [

  {
    selector: '.navbar',
    content: 'This is my first Step',
  },
  {
    selector: '.menu-column',
    content: 'This is my first Step',
  },
  {
    selector: '.workspace-column',
    content: 'This is my first Step',
  },
]

export default steps